import api, { apiErr } from "@/lib/api";
import { PERM_NAV, permCan } from "@/lib/constants";
import { toast } from "sonner";

const COLS = [["view", "Consulter"], ["create", "Créer"], ["edit", "Modifier"], ["delete", "Supprimer"], ["validate", "Valider"], ["export", "Exporter"]];
const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

const buildHtml = (d) => {
  const p = d.permissions;
  const rows = PERM_NAV.map((s) => {
    const items = s.items.map((it) => {
      const cells = COLS.map(([a]) => `<td class="c">${permCan(p, it.module, a) ? "<b class='y'>✓</b>" : "<span class='n'>—</span>"}</td>`).join("");
      const none = !permCan(p, it.module, "view");
      return `<tr class="${none ? "off" : ""}"><td>${esc(it.label)}${d.custom.includes(it.module) ? " <i>(personnalisé)</i>" : ""}</td>${cells}</tr>`;
    }).join("");
    return `<tr class="sec"><td colspan="${COLS.length + 1}">${esc(s.section)}</td></tr>${items}`;
  }).join("");
  const now = new Date().toLocaleString("fr-FR", { dateStyle: "long", timeStyle: "short" });
  return `<!doctype html><html lang="fr"><head><meta charset="utf-8"><title>Accès — ${esc(d.user.name)}</title><style>
  body{font-family:Arial,sans-serif;color:#1C3144;margin:28px;font-size:12px}h1{color:#076633;font-size:20px;margin:0}
  .top{display:flex;justify-content:space-between;align-items:center;border-bottom:3px solid #076633;padding-bottom:10px;margin-bottom:14px}
  table{width:100%;border-collapse:collapse}th,td{border:1px solid #e2e8f0;padding:5px 8px}th{background:#076633;color:#fff;font-size:11px}
  .c{text-align:center;width:70px}.y{color:#076633}.n{color:#cbd5e1}.sec td{background:#f1f5f9;font-weight:bold;text-transform:uppercase;font-size:10px;letter-spacing:.05em}
  .off td{color:#94a3b8}i{color:#b45309;font-size:10px}.meta p{margin:2px 0}.foot{margin-top:24px;display:flex;justify-content:space-between;font-size:11px}
  .sig{width:45%;border-top:1px solid #94a3b8;padding-top:6px}@media print{body{margin:12mm}button{display:none}}</style></head><body>
  <div class="top"><div><h1>Récapitulatif des accès</h1><p>OMNIBAT ONE — édité le ${esc(now)}</p></div><img src="/logo-omnibat.png" alt="OMNIBAT" style="height:46px"></div>
  <div class="meta"><p><b>Utilisateur :</b> ${esc(d.user.name)} — ${esc(d.user.email)}</p><p><b>Rôle :</b> ${esc(d.role_label)}${d.user.function ? ` · ${esc(d.user.function)}` : ""}</p>
  <p><b>Statut :</b> ${d.user.active === false ? "Désactivé" : "Actif"} · ${d.custom.length} module(s) avec droits personnalisés</p></div><br>
  <table><thead><tr><th style="text-align:left">Module / menu</th>${COLS.map(([, l]) => `<th>${l}</th>`).join("")}</tr></thead><tbody>${rows}</tbody></table>
  <div class="foot"><div class="sig">Signature de l'utilisateur</div><div class="sig">Visa de la direction</div></div>
  <script>window.onload=()=>setTimeout(()=>window.print(),300)</script></body></html>`;
};

export async function printAccessReport(uid) {
  const w = window.open("", "_blank");
  try {
    const { data } = await api.get(`/users/${uid}/access`);
    w.document.open(); w.document.write(buildHtml(data)); w.document.close();
  } catch (e) { if (w) w.close(); toast.error(apiErr(e)); }
}
